export default "__VITE_ASSET__ToSmaoAz__"